import { useQuery } from "@tanstack/react-query";
import { getWorkspaceGoggles } from "api/services/workspace-service";
import { IVrGoggleModel } from "api/models/response/goggles/IVrGoggleModel";
import { useAuthContext } from "hooks/useAuthContext";
import { WORKSPACE_GOGGLES_QUERY_KEY } from "hooks/goggles/queryKeys";

export const useGetWorkspaceGoggles = () => {
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const query = useQuery({
        queryKey: [...WORKSPACE_GOGGLES_QUERY_KEY, workspaceId],
        queryFn: async (): Promise<IVrGoggleModel[]> => {
            if (!workspaceId) return [];

            const response = await getWorkspaceGoggles({ workspaceId });
            if (!response.success) {
                throw new Error(response.message ?? "gogglesManagement.loadError");
            }

            return response.data ?? [];
        },
        enabled: !!workspaceId,
    });

    return {
        goggles: query.data ?? [],
        gogglesLoading: query.isLoading || query.isFetching,
        gogglesRefetching: query.isFetching && !query.isLoading,
        refetch: query.refetch,
    };
};
